module.exports = __webpack_public_path__ + "img/arrow-swap.4e122ce8.svg";